import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  MenuItem,
  Modal,
  InputLabel,
  FormControl,
  Grid,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  Table,
  TableHead,
  TableBody,
  Button,
  TableContainer,
  TableCell,
  TableRow,
  Paper,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, // Ensure all dialog components are imported
  Tooltip,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditClass = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("lightOptionValue");
  const [className, setClassName] = useState("");
  const [sequenceNo, setSequenceNo] = useState("");
  const [classType, setClassType] = useState([]);
  const [teacherData, setTeacherData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectionNameValue, setSectionNameValue] = useState("");
  const [seatCapacityValue, setSeatCapacityValue] = useState("");
  const [inchargeValue, setInchargeValue] = useState("");
  const [sectionDetails, setSectionDetails] = useState([]);
  const [chargeDetails, setChargeDetails] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [noOf_BrackLeacture, setNoOf_BrackLeacture] = useState("");
  const [noOfBrack, setNoOfBrack] = useState("");
  const [resultType, setResultType] = useState("");
  const [maxLecture, setMaxLectureAllowed] = useState("");
  const [noBreakCheckbox, setNoBreakCheckbox] = useState(false);
  const [breakAfterLectureNo, setBreakAfterLectureNo] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false); // New state for dialog
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const { classId } = useParams();
  const navigate = useNavigate();

  // Info dialog state
  const [infoOpen, setInfoOpen] = useState(false);

  useEffect(() => {
    const fetchClassDetails = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${apiUrl}/CreateClass/FillClassDetails?Id=${classId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
            body: JSON.stringify({}),
          }
        );
        if (!response.ok) {
          throw new Error(`Error fetching class details: ${response.status}`);
        }
        const data = await response.json();
        const selectedClass = data.find(
          (item) => item.classId === parseInt(classId)
        );
        if (selectedClass) {
          setSelectedValue(selectedClass.classTypeId);
          setClassName(selectedClass.className);
          setSequenceNo(selectedClass.classSequence);
          setMaxLectureAllowed(selectedClass.maxLecture);
          setBreakAfterLectureNo(selectedClass.breakLecture);
          setResultType(selectedClass.resultTypeId.toString());
          setMinAge(selectedClass.classMinAge);
          setMaxAge(selectedClass.classMaxAge);
          setNoBreakCheckbox(selectedClass.breakNumber > 0);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchClassDetails();
  }, [classId]);

  // const handleToggleAll = (event) => {
  //   const checked = event.target.checked;
  //   const updatedChargeDetails = chargeDetails.map((item) => ({ ...item, checked }));
  //   setChargeDetails(updatedChargeDetails);
  //   setSelectAllChecked(checked); // Update the selectAllChecked state
  // };

  const handleToggleAll = (event) => {
    const checked = event.target.checked;
    const updatedChargeDetails = chargeDetails.map((item) => ({
      ...item,
      checked,
      // Preserve the chargeAmount when toggling all
      chargeAmount: item.chargeAmount || 0,
    }));
    setChargeDetails(updatedChargeDetails);
    setSelectAllChecked(checked);
  };

  const fetchClassType = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlClassType`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      setClassType(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchTeacher = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlTeacher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }
      setTeacherData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSection = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlSection`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }

      setSectionData(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")

    }
  };

  const fetchddlcharge = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlChargeDetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }
      setChargeDetails(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchClassSectionDetails = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/CreateClass/FillClassSectionDetails?Id=${classId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error fetching section details: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }
      setSectionDetails(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchClassChargeDetails = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/CreateClass/FillClassChargeDetails?Id=${classId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error fetching charge details: ${response.status}`);
      }
      const data = await response.json();

      // Log the API response to check for duplicates
      console.log("API Response:", data);

      // Remove duplicates based on chargeId
      const uniqueChargeDetails = data.filter(
        (charge, index, self) =>
          index === self.findIndex((c) => c.chargeId === charge.chargeId)
      );

      // Initialize chargeDetails with checked: false and chargeAmount as a number
      const updatedChargeDetails = uniqueChargeDetails.map((charge) => ({
        ...charge,
        checked: (charge.chargeAmount || 0) > 0, // Auto-check if amount > 0
        chargeAmount: parseFloat(charge.chargeAmount || 0).toFixed(1), // Ensure 0.0 when undefined/null
      }));

      setChargeDetails(updatedChargeDetails);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleChargeAmountChange = (event, chargeId) => {
    let value = parseFloat(event.target.value);

    // Prevent NaN (e.g., if the field is cleared)
    if (isNaN(value)) value = 0;

    // Cap the value between 0 and 10000
    value = Math.max(0, Math.min(value, 10000));

    const updatedChargeDetails = chargeDetails.map((charge) =>
      charge.chargeId === chargeId
        ? {
          ...charge,
          chargeAmount: value,
          checked: value > 0,
        }
        : charge
    );

    setChargeDetails(updatedChargeDetails);

    // Update selectAllChecked state
    const allChecked = updatedChargeDetails.every((item) => item.checked);
    setSelectAllChecked(allChecked);
  };

  const handleIndividualCheckboxChange = (chargeId) => {
    const updatedChargeDetails = chargeDetails.map((charge) =>
      charge.chargeId === chargeId
        ? { ...charge, checked: !charge.checked }
        : charge
    );
    setChargeDetails(updatedChargeDetails);

    // Update selectAllChecked based on whether all items are checked
    const allChecked = updatedChargeDetails.every((item) => item.checked);
    setSelectAllChecked(allChecked);
  };

  const handleAddSectionDetails = () => {
    // Find the selected section object using its ID
    const selectedSection = sectionData.find(
      (section) => section.sectionId === sectionNameValue
    );

    // Create a new section object with the selected section's name and other details
    const newSection = {
      sectionId: sectionNameValue,
      sectionName: selectedSection ? selectedSection.sectionName : "",
      seatCapacity: seatCapacityValue,
      incharge:
        teacherData.find((teacher) => teacher.employeeId === inchargeValue)
          ?.employeeName || "",
      inchargeId: inchargeValue,
    };

    // Add the new section to the sectionDetails state
    setSectionDetails([...sectionDetails, newSection]);

    // Clear section details fields
    setSectionNameValue("");
    setSeatCapacityValue("");
    setInchargeValue("");
  };

  const handleDeleteSection = (index) => {
    const updatedSectionDetails = [...sectionDetails];
    updatedSectionDetails.splice(index, 1);
    setSectionDetails(updatedSectionDetails);
  };

  const handleCancel = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleSave = async () => {
    try {
      const Url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${Url}/CreateClass?Id=${classId}`;
      const token = sessionStorage.getItem("token");

      const sectionsData = sectionDetails.map((section) => ({
        sectionId: section.sectionId,
        seactCapacity: section.seatCapacity,
        teacherId: section.inchargeId || section.teacherId,
      }));

      const classChargeData = chargeDetails
        .filter((charge) => charge.checked)
        .map((charge) => ({
          charge: charge.chargeAmount || 0,
          chargeId: charge.chargeId,
        }));

      const requestBody = {
        className,
        sequenceNo: sequenceNo || 0,
        classTypeId: selectedValue,
        classMinAge: minAge,
        classMaxAge: maxAge,
        noOf_BrackLeacture: breakAfterLectureNo || 0,
        no_OfBrack: 1,
        maxLecture,
        resultType,
        sectionsData,
        classChargeData,
      };

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`Error posting data: ${response.status}`);
      }

      const responseData = await response.json();

      if (
        responseData.status === "Failed!" &&
        responseData.msg === "Class Name already exist!"
      ) {
        // alert(responseData.msg);
        setSnackbarMessage(responseData.msg);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      } else {
        setShowSuccessModal(true); // Show success dialog
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDialogClose = () => {
    setOpenSuccessDialog(false);
    navigate(-1); // Navigate back after closing dialog
  };

  useEffect(() => {
    const loadChargesInOrder = async () => {
      await fetchddlcharge(); // First get list of all possible charges
      await fetchClassChargeDetails(); // Then get charge values for this class
    };

    fetchClassType();
    fetchTeacher();
    fetchSection();
    fetchClassSectionDetails();

    loadChargesInOrder(); // Use the wrapper to control the order
  }, []);

  const handleMaxLectureChange = (event) => {
    setMaxLectureAllowed(event.target.value);
  };

  // Handle change for No break checkbox
  const handleNoBreakCheckboxChange = (event) => {
    setNoBreakCheckbox(event.target.checked);
  };

  // Handle change for Break after Lecture No.
  const handleBreakAfterLectureChange = (event) => {
    setBreakAfterLectureNo(event.target.value);
  };

  // Handle change for Min Age
  const handleMinAgeChange = (event) => {
    setMinAge(event.target.value);
  };

  // Handle change for Max Age
  const handleMaxAgeChange = (event) => {
    setMaxAge(event.target.value);
  };

  // const handleChargeAmountChange = (event, chargeId) => {
  //   const value = event.target.value;
  //   const updatedChargeDetails = chargeDetails.map((charge) =>
  //     charge.chargeId === chargeId ? { ...charge, chargeAmount: value } : charge
  //   );
  //   setChargeDetails(updatedChargeDetails);
  // };

  // const handleIndividualCheckboxChange = (index) => {
  //   const updatedChargeDetails = [...chargeDetails];
  //   updatedChargeDetails[index].checked = !updatedChargeDetails[index].checked;

  //   setChargeDetails(updatedChargeDetails);

  //   // Update selectAllChecked state
  //   const allChecked = updatedChargeDetails.every((item) => item.checked);
  //   setSelectAllChecked(allChecked);
  // };

  return (
    <Container>
      {/* Header Box with Title + Info Button */}
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Class
        </Typography>

        {/* ── Info Button ── */}
        <Tooltip title="About this page" arrow>
          <IconButton
            onClick={() => setInfoOpen(true)}
            size="small"
            sx={{
              color: "rgba(255,255,255,0.75)",
              border: "1.5px solid rgba(255,255,255,0.35)",
              borderRadius: "50%",
              width: 30,
              height: 30,
              ml: 0.5,
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#ffffff",
                backgroundColor: "rgba(100,181,246,0.2)",
                borderColor: "#64B5F6",
                transform: "scale(1.1)",
                boxShadow: "0 0 8px rgba(100,181,246,0.4)",
              },
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <Grid container spacing={4} sx={{ marginTop: 1 }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="class-label">Class Type</InputLabel>
              <Select
                labelId="class-label"
                id="class"
                label="Class Type"
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                {classType.map((item) => (
                  <MenuItem key={item.classTypeId} value={item.classTypeId}>
                    {item.classType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id="sequence"
              label="Sequence No."
              variant="outlined"
              fullWidth
              value={sequenceNo}
              onChange={(e) => setSequenceNo(e.target.value)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ marginTop: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              id="className"
              label="Class Name"
              variant="outlined"
              fullWidth
              value={className}
              onChange={(e) => setClassName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="resultType-label">Result Type</InputLabel>
              <Select
                labelId="resultType-label"
                id="resultType"
                label="Result Type"
                value={resultType}
                onChange={(e) => setResultType(e.target.value)}
              >
                <MenuItem value="">--Select--</MenuItem>
                <MenuItem value="1">Grading Wise</MenuItem>
                <MenuItem value="2">Division Wise</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ marginTop: -1 }}>
          <Grid item xs={12} md={6}>
            <Box component={Paper} sx={{ p: 2 }}>
              {/* Lecture details */}
              <Typography variant="h6" sx={{ mb: 4 }}>
                <strong>Lecture Details</strong>
              </Typography>
              <TextField
                id="max-lecture-allowed"
                label="Max Lecture Allowed"
                variant="outlined"
                fullWidth
                value={maxLecture}
                onChange={handleMaxLectureChange}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    id="no-break-checkbox"
                    checked={noBreakCheckbox}
                    onChange={handleNoBreakCheckboxChange}
                  />
                }
                label="No break for the Class"
              />
              <TextField
                id="break-after-lecture-no"
                label="Break after Lecture No."
                variant="outlined"
                fullWidth
                value={breakAfterLectureNo}
                onChange={handleBreakAfterLectureChange}
              />
              <div style={{ display: "flex", marginTop: 10 }}>
                <TextField
                  id="min-age"
                  label="Min Age"
                  variant="outlined"
                  sx={{ mr: 1 }}
                  value={minAge}
                  onChange={handleMinAgeChange}
                />
                <TextField
                  id="max-age"
                  label="Max Age"
                  variant="outlined"
                  value={maxAge}
                  onChange={handleMaxAgeChange}
                />
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box component={Paper} sx={{ p: 2 }}>
              {/* Section details */}
              <Typography variant="h6" sx={{ mb: 2 }}>
                <strong>Add Section Details</strong>
              </Typography>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="section-label">Section</InputLabel>
                <Select
                  labelId="section-label"
                  id="section"
                  label="Section"
                  value={sectionNameValue}
                  onChange={(e) => setSectionNameValue(e.target.value)}
                >
                  <MenuItem value="">Select</MenuItem>
                  {sectionData.map((item) => (
                    <MenuItem key={item.sectionId} value={item.sectionId}>
                      {item.sectionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                id="seat-capacity"
                label="Seat Capacity"
                variant="outlined"
                fullWidth
                value={seatCapacityValue}
                onChange={(e) => setSeatCapacityValue(e.target.value)}
                sx={{ mb: 2 }}
              />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="incharge-label">Incharge</InputLabel>
                <Select
                  labelId="incharge-label"
                  id="incharge"
                  label="Incharge"
                  value={inchargeValue}
                  onChange={(e) => setInchargeValue(e.target.value)}
                >
                  <MenuItem value="">Select</MenuItem>
                  {teacherData.map((item) => (
                    <MenuItem key={item.employeeId} value={item.employeeId}>
                      {item.employeeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                onClick={handleAddSectionDetails}
                startIcon={<Add />}
                variant="contained"
              >
                Add Section
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={3} sx={{ marginTop: 3 }}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: '#0B1F40', // dark navy blue
              padding: '12px 24px',
              boxShadow: 3,
              borderRadius: '4px 4px 0 0',
              margin: '2px auto',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Class Charges
            </Typography> </Box>
          <Paper sx={{ p: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        checked={selectAllChecked}
                        onChange={handleToggleAll}
                        indeterminate={
                          chargeDetails.some((item) => item.checked) &&
                          !selectAllChecked
                        }
                      />
                    </TableCell>
                    <TableCell>Charge Name</TableCell>
                    <TableCell>Charge Type</TableCell>
                    <TableCell>Charge Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {chargeDetails.map((item) => (
                    <TableRow key={item.chargeId}>
                      <TableCell>
                        <Checkbox
                          checked={item.checked || false}
                          onChange={() =>
                            handleIndividualCheckboxChange(item.chargeId)
                          }
                        />
                      </TableCell>
                      <TableCell>{item.chargeName}</TableCell>
                      <TableCell>{item.chargeType}</TableCell>
                      <TableCell>
                        <TextField
                          variant="outlined"
                          type="number"
                          value={item.chargeAmount} // No need for || "" since chargeAmount is always a number
                          onChange={(event) =>
                            handleChargeAmountChange(event, item.chargeId)
                          }
                          size="small"
                          sx={{ width: "120px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ textAlign: "right", marginTop: '7px' }}>
              <Button onClick={handleSave} variant="contained" color="primary">
                UPDATE
              </Button>
              <Button
                onClick={handleCancel}
                variant="contained"
                color="error"
                sx={{ ml: 1 }}
              >
                Cancel
              </Button>
            </div>
          </Paper>
        </Grid>
        {/* Success Dialog */}
        <Dialog open={openSuccessDialog} onClose={handleDialogClose}>
          <DialogTitle>Success</DialogTitle>
          <DialogContent>
            <Typography>Data saved successfully!</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleDialogClose}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        {/* Section Details table */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: '#0B1F40', // dark navy blue
              padding: '12px 24px',
              boxShadow: 3,
              borderRadius: '4px 4px 0 0',
              margin: '2px auto',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Section Details List
            </Typography> </Box>


          <Paper sx={{ p: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Section Name</TableCell>
                    <TableCell>Seat Capacity</TableCell>
                    <TableCell>Incharge</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sectionDetails.map((section, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {section.sectionName || section.section}
                      </TableCell>
                      <TableCell>{section.seatCapacity}</TableCell>
                      <TableCell>
                        {section.incharge || section.teacherName}
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={() => handleDeleteSection(index)}
                          startIcon={<Delete />}
                          color="error"
                          size="small"
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Class Updated ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Class has been Updated successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

      {/* ── Info Dialog ── */}
      <Dialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px",
            boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
            color: "#ffffff",
            fontWeight: 700,
            fontSize: "1.2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <InfoOutlinedIcon sx={{ fontSize: 22 }} />
            Edit Class — Page Guide
          </Box>
          <IconButton
            onClick={() => setInfoOpen(false)}
            size="small"
            sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { color: "#fff" } }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 2.5 }}>

          {/* Purpose */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
            This page allows you to modify an existing class record. You can update the class name,
            type, lecture settings, age restrictions, section assignments, and associated fee charges,
            then save all changes using the UPDATE button.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {/* Sections */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Form Sections Explained
          </Typography>

          <List dense disablePadding>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SchoolIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Class Info (Top Section)</Typography>}
                secondary="Update the Class Type, Sequence Number, Class Name, and Result Type (Grading Wise or Division Wise)."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <EventSeatIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Lecture Details</Typography>}
                secondary="Set the maximum number of lectures allowed, configure break settings (toggle 'No break' or enter break after lecture number), and define the minimum and maximum student age."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <MeetingRoomOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Add Section Details</Typography>}
                secondary="Select a section, enter seat capacity, assign an incharge teacher, then click 'Add Section' to attach it to the class. Added sections appear in the Section Details List on the right."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <Delete sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Section Details List</Typography>}
                secondary="View all sections assigned to this class. Use the Delete button on any row to remove a section from the list before saving."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <PaymentsOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Class Charges</Typography>}
                secondary="Check the charges applicable to this class and enter their amounts (max ₹10,000 per charge). Charges with an amount greater than 0 are auto-checked. Use the header checkbox to select or deselect all charges at once."
              />
            </ListItem>

          </List>

          <Divider sx={{ my: 2 }} />

          {/* Important notes */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Important Notes
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {[
              "Class Name must be unique — duplicate names will show an error.",
              "Charge amounts are capped between 0 and 10,000.",
              "Entering an amount > 0 automatically checks that charge row.",
              "Only checked charges are included when saving.",
              "Clicking UPDATE saves all changes including sections and charges.",
              "Clicking Cancel navigates back without saving.",
            ].map((note, i) => (
              <Typography key={i} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5, lineHeight: 1.6 }}>
                {note}
              </Typography>
            ))}
          </Box>

        </DialogContent>

        <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
          <Button
            onClick={() => setInfoOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#0B1F3D",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#1565C0" },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
      {/* ── End Info Dialog ── */}

    </Container>
  );
};

export default EditClass;